import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hasExtractedValue',
  standalone: true,
})
export class HasExtractedValuePipe implements PipeTransform {
  private datePipe = new DatePipe('it-IT');

  transform(value: any): boolean {
    if (value === null || value === undefined || value === '—') {
      return false;
    }

    // Return as string for regular values
    if (Array.isArray(value) && value.length === 0) {
      return false;
    }
    return true;
  }

  private isDate(value: any): boolean {
    // If it's already a Date object
    if (value instanceof Date) {
      console.log('Date object:', value);
      return !isNaN(value.getTime());
    }

    // If it's a string, check for yyyy-mm-dd format
    if (typeof value === 'string') {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(value)) {
        return false;
      }

      // Validate it's a real date
      const date = new Date(value);
      return !isNaN(date.getTime());
    }

    return false;
  }

  private formatDate(value: any): string {
    // Use Angular's DatePipe with Italian format (dd/MM/yyyy)
    const formatted = this.datePipe.transform(value, 'dd/MM/yyyy');
    return formatted || String(value);
  }

  private isNumber(value: any): boolean {
    // Only format actual number types as currency, not strings
    if (typeof value === 'number' && !isNaN(value)) {
      return true;
    }

    return false;
  }

  private formatNumber(value: any): string {
    const numValue = typeof value === 'number' ? value : parseFloat(value);

    if (isNaN(numValue)) {
      return String(value);
    }

    // Format with Italian locale (. for thousands, , for decimals)
    const formatted = new Intl.NumberFormat('it-IT', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(numValue));

    // Add € symbol and handle negative values
    if (numValue < 0) {
      return `- ${formatted}`;
    } else {
      return `${formatted}`;
    }
  }
}
